require("./main-menu-desktop");
require("./main-menu-mobile");

(function () {
  function setScrollbarWidth() {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    outer.style.msOverflowStyle = "scrollbar";
    outer.style.width = "100px";
    outer.style.height = "100px";
    document.body.appendChild(outer);

    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.remove();

    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${scrollbarWidth}px`
    );
  }

  window.addEventListener("DOMContentLoaded", function () {
    setScrollbarWidth();
    window.addEventListener("resize", setScrollbarWidth);

    const burgerWrapper = document.querySelector(".burger__wrapper");
    const btnHighlights = document.querySelectorAll(".btn-highlight a");

    if (burgerWrapper) {
      btnHighlights.forEach((btn) => {
        const btnHighlightLink = btn.getAttribute("href");
        const btnHighlightText = btn.textContent;
        const newBtnHighlightLink = document.createElement("a");

        newBtnHighlightLink.textContent = btnHighlightText;
        newBtnHighlightLink.href = btnHighlightLink;
        newBtnHighlightLink.classList.add(
          "button",
          "button--amber",
          "button--xs"
        );
        burgerWrapper.prepend(newBtnHighlightLink);
      });
    }

    //Slider
    const slider = document.querySelector(".slider");

    // Slide forward/backward.
    const slideForward = () => {
      // Recalculate cardWidth in case of window resize.
      const cardWidth = slider.querySelector(".slider__items > *").offsetWidth;
      slider.scrollBy(window.innerWidth - 2 * cardWidth, 0);
    };
    const slideBackward = () => {
      // Recalculate cardWidth in case of window resize.
      const cardWidth = slider.querySelector(".slider__items > *").offsetWidth;

      slider.scrollBy(-window.innerWidth + 2 * cardWidth, 0);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target.className.includes("start")) {
            slider.classList.toggle("slider_start", entry.isIntersecting);
          }
          if (entry.target.className.includes("end")) {
            slider.classList.toggle("slider_end", entry.isIntersecting);
          }
        });
      },
      {
        root: slider,
      }
    );

    if (slider) {
      slider
        .querySelector(".slider__prev")
        .addEventListener("click", slideBackward);
      slider
        .querySelector(".slider__next")
        .addEventListener("click", slideForward);

      const observed = slider.querySelectorAll(
        ".slider__start-gutter, .slider__end-gutter"
      );
      observed.forEach((el) => observer.observe(el));
    }

    //Language dropdown
    const languageBlocks = document.querySelectorAll(".language");

    languageBlocks.forEach((language) => {
      const languageMenu = language.querySelector(".language__menu");
      if (!languageMenu) return;

      language.addEventListener("click", (e) => {
        e.stopPropagation();
        languageBlocks.forEach((item) => {
          if (item !== language) {
            item.querySelector(".language__menu")?.classList.remove("open");
          }
        });
        languageMenu.classList.toggle("open");
      });
    });

    document.addEventListener("click", () => {
      languageBlocks.forEach((language) => {
        language.querySelector(".language__menu")?.classList.remove("open");
      });
    });
  });
})();

(function () {
  const body = document.body;
  const button = document.getElementById("sticky-cta-button");
  const footer = document.getElementById("main-footer");

  let isVisibleMemo = false;
  if (!button || !footer) return;

  const isFooterVisible = () => {
    const footerRect = footer.getBoundingClientRect();
    return footerRect.top <= window.innerHeight && footerRect.bottom >= 0;
  };

  window.addEventListener("scroll", () => {
    const scrollLimit = window.innerHeight;
    const isVisible = window.scrollY > scrollLimit && !isFooterVisible();

    if (isVisible === isVisibleMemo) return;

    isVisibleMemo = isVisible;
    button.dataset.animate = true;

    button.addEventListener(
      "transitionend",
      (e) => {
        if (e.target !== button) return;
        button.dataset.animate = false;
      },
      { once: true }
    );

    if (isVisible) {
      button.dataset.hidden = false;
      cardVisible = true;
      body.classList.add("sticky-cta-visible");
      return;
    }

    button.dataset.hidden = true;
    cardVisible = false;
    body.classList.remove("sticky-cta-visible");
  });
})();
